// Wrapper component that shows desktop or mobile version based on screen size.
import OwletAIDesktop from './OwletAIDesktop';
import OwletAIMobile from './OwletAIMobile';

export default function OwletAI() {
  return (
    <>
      {/* Desktop version - hidden on mobile/tablet */}
      <div className="hidden lg:block">
        <OwletAIDesktop />
      </div>

      {/* Mobile version - hidden on desktop */}
      <div className="lg:hidden">
        <OwletAIMobile />
      </div>
    </>
  );
}
